import type { FwQueryState } from "@/components/fw/data-table/useFwQuery";
import type { StorefrontOrderDto } from "@/lib/storefront-api";
import { OrderTable } from "./order-table";

export interface OrdersControlProps {
	query: FwQueryState<StorefrontOrderDto>;
}

export function OrdersControl({ query }: OrdersControlProps) {
	return <OrderTable query={query} />;
}
